module.exports = __webpack_public_path__ + "img/blank-comic-book_B098WDGQHP.e9c4540e.jpg";